import { useEffect, useState } from "react";
import api from "../api/client";
import "./Leaderboard.css";

const PRIZES = [
  { rank: "🏆", label: "1st", reward: "not fixed" },
  { rank: "🥈", label: "2nd", reward: "not fixed" },
  { rank: "🥉", label: "3rd", reward: "not fixed" },
  { rank: "", label: "4th - 7th", reward: "not fixed" },
  { rank: "", label: "8th - 10th", reward: "not fixed" },
];

function getTimeLeft() {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
  const diff = end - now;
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff % 86400000) / 3600000),
    m: Math.floor((diff % 3600000) / 60000),
    s: Math.floor((diff % 60000) / 1000),
  };
}

export default function Leaderboard() {
  const [data, setData] = useState(null);
  const [month, setMonth] = useState("");
  const [time, setTime] = useState(getTimeLeft());
  const [showPrize, setShowPrize] = useState(true);

  useEffect(() => {
    api.get("/product/leaderboard").then((r) => {
      setData(r.data.leaderboard);
      setMonth(r.data.month || "");
    }).catch(() => setData([]));
  }, []);

  useEffect(() => {
    const t = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!data) return <div className="lb-loading"><div className="home-spinner" /><span>Loading leaderboard...</span></div>;

  return (
    <div className="lb">
      {/* Countdown */}
      <div className="lb-countdown">
        <span className="lb-countdown-icon">⏳</span>
        <span>The Challenge ends in: <strong>{time.d}d {time.h}h {time.m}m {time.s}s</strong></span>
      </div>

      {/* Prize Pool Popup */}
      {showPrize && (
        <div className="lb-prize-card">
          <button className="lb-prize-close" onClick={() => setShowPrize(false)}>✕</button>
          <h2 className="lb-prize-title">🏆 Monthly Challenge</h2>
          <p className="lb-prize-desc">
            This is a monthly challenge where everyone has a chance to win rewards based on their position on the leaderboard.
          </p>

          <h3 className="lb-prize-how">How does it work?</h3>
          <p className="lb-prize-desc">
            Your position is determined by the total amount you purchase this month. The more you purchase, the higher you climb!
          </p>

          <h3 className="lb-prize-pool-title">Prize Pool</h3>
          <div className="lb-prize-list">
            {PRIZES.map((p, i) => (
              <div key={i} className={`lb-prize-row lb-prize-tier-${i}`}>
                <span className="lb-prize-rank">{p.rank}</span>
                <span className="lb-prize-label">{p.label}</span>
                <span className="lb-prize-reward">🪙 {p.reward}</span>
              </div>
            ))}
          </div>

          <p className="lb-prize-note">
            At the end of every month, each player on the leaderboard will receive a reward based on their rank. Keep purchasing to rise the ranks!
          </p>

          <button className="lb-prize-cta" onClick={() => setShowPrize(false)}>View Leaderboard ↓</button>
        </div>
      )}

      {/* Leaderboard Table */}
      <div className="lb-board">
        <div className="lb-board-header">
          <h2>🏆 Top Players — {month}</h2>
          {!showPrize && <button className="lb-show-prizes" onClick={() => setShowPrize(true)}>View Prizes</button>}
        </div>

        <div className="lb-table-head">
          <span>Ranking</span>
          <span>User</span>
          <span style={{ textAlign: "right" }}>Total Spent</span>
        </div>

        {data.length === 0 && <p className="muted" style={{ textAlign: "center", padding: 40 }}>No purchases this month yet.</p>}

        {data.map((u, i) => (
          <div key={i} className={`lb-entry${i < 3 ? ` lb-top lb-top-${i + 1}` : ""}`}>
            <div className="lb-entry-rank">
              {i === 0 && <span className="lb-trophy">🏆</span>}
              {i === 1 && <span className="lb-trophy">🥈</span>}
              {i === 2 && <span className="lb-trophy">🥉</span>}
              {i >= 3 && <span className="lb-rank-num">{i + 1}</span>}
            </div>
            <div className="lb-entry-user">
              <div className="lb-avatar">{(u.name || "?")[0].toUpperCase()}</div>
              <span className="lb-name">{u.name || "Anonymous"}</span>
            </div>
            <div className="lb-entry-spent">
              <span className="lb-amount">₹{u.totalSpent.toLocaleString("en-IN")}</span>
              <span className="lb-arrow">›</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
